import {
  Stack,
  TableCell,
  TableHead as MuiTableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { flexRender, Table } from "@tanstack/react-table";

export const TableHead = <T extends object>({ table }: { table: Table<T> }) => {
  const theme = useTheme();

  return (
    <MuiTableHead>
      {table.getHeaderGroups().map((headerGroup) => (
        <TableRow key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <TableCell
              key={header.id}
              colSpan={header.colSpan}
              className={`${header.column.getSize()}`}
              sx={
                header.column.getSize()
                  ? {
                      width: `${header.column.getSize()}%`,
                    }
                  : {}
              }
            >
              {header.isPlaceholder ? null : (
                <Stack
                  direction={"row"}
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: header.column.getCanSort() ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (header.column.getCanSort()) {
                      header.column.toggleSorting();
                    }
                  }}
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                  {header.column.getCanSort() && (
                    <Stack spacing={-1.5} sx={{ ml: 1 }}>
                      <KeyboardArrowUpIcon
                        sx={{
                          color:
                            header.column.getIsSorted() == "asc"
                              ? theme.palette.secondary.main
                              : theme.palette.grey[400],
                        }}
                      />
                      <KeyboardArrowDownIcon
                        sx={{
                          color:
                            header.column.getIsSorted() == "desc"
                              ? theme.palette.secondary.main
                              : theme.palette.grey[400],
                        }}
                      />
                    </Stack>
                  )}
                </Stack>
              )}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </MuiTableHead>
  );
};
